export const LOAD_IMPORT_STATISTICS = 'LOAD_IMPORT_STATISTICS';
export const LOAD_IMPORT_STATISTICS_START = `${LOAD_IMPORT_STATISTICS}_START`;
export const LOAD_IMPORT_STATISTICS_SUCCESS = `${LOAD_IMPORT_STATISTICS}_SUCCESS`;
export const LOAD_IMPORT_STATISTICS_FAIL = `${LOAD_IMPORT_STATISTICS}_FAIL`;

export const PAGE = 'PAGE_IMPORT_STATISTICS';
export const PAGE_START = `${PAGE}_START`;
export const PAGE_SUCCESS = `${PAGE}_SUCCESS`;
export const PAGE_FAIL = `${PAGE}_FAIL`;

const getUri = importId => `/webapi/xm/1/imports/${importId}/statistics`;

const defaultParams = {
  offset: 0,
  limit: 100,
};

function apiLoadImportStatistics(importJobId, type, params = {}) {
  return {
    type,
    meta: {
      xmApi: true,
      method: 'getall',
      uri: getUri(importJobId),
      params: {
        ...defaultParams,
        ...params,
      },
    },
  };
}

export function loadImportStatistics(importJobId, params) {
  return apiLoadImportStatistics(importJobId, LOAD_IMPORT_STATISTICS, params);
}
